import React, { useState } from 'react'
import Container from 'components/Container'
import { getSigner } from 'utils'
import { useDropzone } from 'react-dropzone'
import { CardBody, Button, LinkExternal } from '@pancakeswap-libs/uikit'
import * as XLSX from 'xlsx'
import { RowBetween } from 'components/Row'
import { Contract } from 'ethers'
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import BigNumber from 'bignumber.js'
import AppBody from '../AppBody'
import { Wrapper, Title, WarnTip } from './styleds'
import Mint_Token_ABI from '../../constants/abis/mintToken.json'
import { useActiveWeb3React } from '../../hooks'

export default function TokenMint({ match }) {
  const { tokenAddress, decimals } = match.params
  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()
  const { account, chainId, library } = useActiveWeb3React()
  const [fileData, setFileData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  // ✅ 检测是否为移动设备
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile/i.test(navigator.userAgent)

  const onDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = new Uint8Array(e.target?.result as ArrayBuffer)
        const workbook = XLSX.read(data, { type: 'array' })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

        const jsonDataFilter = jsonData.filter((item: any) => {
          return item.length === 2
        })
        setFileData(jsonDataFilter)
      }
      reader.readAsArrayBuffer(file)
    }
  }

  const accept = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.ms-excel': ['.xls'],
  }

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept,
    maxFiles: 1,
    noDrag: isMobile, // ✅ 禁用拖拽上传（移动端）
    noClick: true,     // ✅ 禁用自动点击
  })
  const handleDownloadTemplate = () => {
    const link = document.createElement('a')
    link.href = 'https://memeswap888.github.io/case/case.xlsx'
    link.setAttribute('download', 'case.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
  const handleMint = async () => {
    if (!chainId || !library || !account || !tokenAddress || !decimals) return
    setLoading(true)
    try {
      if (fileData.length <= 0) {
        toastError(t('Excel upload error'))
        return
      }
      if (fileData.length > 201) {
        toastError(t('The number of addresses cannot exceed 200'))
        return
      }
      const addressList = fileData.slice(1).map((item: any) => item[0])
      const amountList = fileData.slice(1).map((item: any) =>
        new BigNumber(item[1]).multipliedBy(10 ** decimals).toFixed()
      )
      const contract = new Contract(tokenAddress, Mint_Token_ABI, getSigner(library, account))
      const tx = await contract.batchMint(addressList, amountList)
      await tx.wait()
      toastSuccess(t('Mint success'))
      setFileData([])
    } catch (err) {
      toastError(t('Mint failed'))
      setFileData([])
    }
    setLoading(false)
  }

  return (
    <Container>
      <AppBody>
        <Wrapper>
          <Title>{t('Batch mint')}</Title>

          <CardBody>
            <RowBetween>
              <span />
              <Button variant="text" onClick={handleDownloadTemplate} style={{ marginBottom: '0.5rem' }}>
                {t('Download Template')}
              </Button>
            </RowBetween>

            {/* ✅ 文件上传区域 */}
            <div
              {...getRootProps()}
              style={{
                border: '2px dashed #cccccc',
                padding: '1rem',
                textAlign: 'center',
                marginBottom: '1rem',
                backgroundColor: isMobile ? '#fafafa' : undefined,
              }}
            >
              <input {...getInputProps()} />
              {isMobile ? (
                <Button onClick={open}>{t('Click to upload Excel file')}</Button>
              ) : (
                <p>{t('Drag and drop an Excel file here, or click to select')}</p>
              )}
            </div>

            {/* ✅ 表格预览 */}
            <div style={{ maxHeight: '20vh', overflowY: 'auto', marginBottom: '1rem' }}>
              {fileData.length > 0 && (
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      {fileData[0].map((header: any, index: number) => (
                        <th
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                          style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {fileData.slice(1).map((row: any, rowIndex: number) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <tr key={rowIndex}>
                        {row.map((cell: any, cellIndex: number) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <td key={cellIndex} style={{ border: '1px solid #ccc', padding: '8px' }}>
                            {cell.length >= 42
                              ? `${cell.substring(0, 5)}...${cell.substring(cell.length - 5)}`
                              : cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <WarnTip>
              {t('The upload file can contain up to 200 records')}
              <br />
              <LinkExternal target='_blank' href='https://bscscan.com/exportData?type=tokenholders'>
                {t('Export bsc chain token holder information')}
              </LinkExternal>
              <LinkExternal target='_blank' href='https://cn.etherscan.com/exportData?type=tokenholders'>
                {t('Export eth chain token holder information')}
              </LinkExternal>
            </WarnTip>

            {fileData.length <= 0 ? (
              <Button disabled width='100%'>
                {t('Please upload the excel file first')}
              </Button>
            ) : (
              <Button width='100%' disabled={loading} onClick={handleMint}>
                {loading ? `${t('Batch mint')}...` : t('Batch mint')}
              </Button>
            )}
          </CardBody>
        </Wrapper>
      </AppBody>
    </Container>
  )
}
